import { render, staticRenderFns } from "./ProductHistoryItem.vue?vue&type=template&id=030597a8&scoped=true"
import script from "./ProductHistoryItem.vue?vue&type=script&lang=js"
export * from "./ProductHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./ProductHistoryItem.vue?vue&type=style&index=0&id=030597a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030597a8",
  null
  
)

export default component.exports